import { ReferralProp } from '../interfaces/Referral';
import apiService from './api.service';

class ReferralService {
  // Cache per i dati referral
  private referralLinkCache: { data: any; timestamp: number } = { data: null, timestamp: 0 };
  private referralDataCache: { data: ReferralProp | null; timestamp: number } = { data: null, timestamp: 0 };
  private CACHE_DURATION = 5 * 60 * 1000; // 5 minuti

  // Ottieni il link referral dell'utente
  async getReferralLink(forceRefresh = false): Promise<{ referral_link: string; referral_code: string; referral_active: boolean }> {
    if (!forceRefresh && this.referralLinkCache.data &&
      Date.now() - this.referralLinkCache.timestamp < this.CACHE_DURATION) {
      return this.referralLinkCache.data;
    }

    const response = await apiService.get('/users/referral/referral-link/');
    
    // Salva in cache
    this.referralLinkCache = {
      data: response.data,
      timestamp: Date.now()
    };

    return response.data;
  }

  // Ottieni i dati referral (invitati completati/scaduti)
  async getReferralData(forceRefresh = false): Promise<ReferralProp> {
    if (!forceRefresh && this.referralDataCache.data &&
      Date.now() - this.referralDataCache.timestamp < this.CACHE_DURATION) {
      return this.referralDataCache.data;
    }

    const response = await apiService.get('/users/referral/invited/');
    
    // Trasforma la response dell'API nel formato corretto
    const rawData = response.data;
    const transformedData: ReferralProp = {
      pending: [],
      expired: [],
      completed: []
    };

    // Filtra i dati in base allo status
    rawData.forEach((item: any) => {
      switch (item.status) {
        case 0: // PENDING
          transformedData.pending.push(item);
          break;
        case 1: // ACCEPTED
          transformedData.completed.push(item);
          break;
        case 2: // REJECTED
          transformedData.expired.push(item);
          break;
        case 3: // ACCEPTED_WITH_NO_CREDS
          transformedData.completed.push(item);
          break;
        default:
          transformedData.pending.push(item);
      }
    });

    // Salva in cache
    this.referralDataCache = {
      data: transformedData,
      timestamp: Date.now()
    };

    return transformedData;
  }

  // Invalida la cache
  clearCache(): void {
    this.referralLinkCache = { data: null, timestamp: 0 };
    this.referralDataCache = { data: null, timestamp: 0 };
  }

  invalidateReferralLinkCache(): void {
    this.referralLinkCache = { data: null, timestamp: 0 };
  }

  invalidateReferralDataCache(): void {
    this.referralDataCache = { data: null, timestamp: 0 };
  }
}

// Esporta istanza singleton
const referralService = new ReferralService();
export default referralService;
